// extracted by mini-css-extract-plugin
export default {"localizationEnvironment":"localizationEnvironment_localizationEnvironment__xO7Do","contentMap":"localizationEnvironment_contentMap__cdVVr"};